export const LEAVE_APPLICATION_DEFAULT_VALUES = {
  leaveType: '',
  startDate: '',
  startSession: '',
  endDate: '',
  endSession: '',
  reason: '',
  attachment: null,
};

export const ADMIN_LEAVE_APPLICATION_DEFAULT_VALUES = {
  employeeId: '',
  leaveType: '',
  startDate: '',
  startSession: '',
  endDate: null,
  endSession: null,
  reason: '',
  attachment: null,
};
